import { useQuery } from '@tanstack/react-query'

import chatService from '../services'
import { chatKeys } from '../../keys'

export function useQueryPinnedMessages(roomId: string, enabled = true) {
	return useQuery({
		queryKey: chatKeys.pinnedMessages(roomId),
		queryFn: () => chatService.getPinnedMessages(roomId),
		enabled: enabled && !!roomId,
	})
}
